import { toSupportedDeviceTypes } from '@/shared-responder-v2';
import {
  DEVICE_GATE_VERDICTS,
  resolveDeviceGate,
  VIEWPORT_CLASSES,
  type ViewportClass,
} from '@/shared-responder-v2-core';

export const MOBILE_UT_ENTRIES = {
  /** This page is the survey running inside the Hyperbeam VM the phone drives. */
  Vm: 'vm',
  /** This page is the phone: it streams the VM instead of answering itself. */
  PhoneHandoff: 'phoneHandoff',
  /** This page answers on the device it is open on — every non-relayed session. */
  Direct: 'direct',
} as const;

export type MobileUtEntry =
  (typeof MOBILE_UT_ENTRIES)[keyof typeof MOBILE_UT_ENTRIES];

/**
 * Whether a phone-sized responder may take this project at all, asked of the
 * device gate itself rather than re-derived: a project with no `deviceTypes`
 * never restricted devices and so fails open, which is the one rule a second
 * copy of this predicate would be certain to get wrong.
 */
export function supportsPhoneResponders(
  deviceTypes: readonly string[] | null | undefined
): boolean {
  return (
    resolveDeviceGate({
      supportedDeviceTypes: toSupportedDeviceTypes(deviceTypes),
      viewportClass: VIEWPORT_CLASSES.Mobile,
    }) === DEVICE_GATE_VERDICTS.Allowed
  );
}

export function resolveMobileUtEntry({
  isInsideVm,
  viewportClass,
  hasUrlOrTask,
  supportsPhone,
}: {
  readonly isInsideVm: boolean;
  readonly viewportClass: ViewportClass;
  readonly hasUrlOrTask: boolean;
  readonly supportsPhone: boolean;
}): MobileUtEntry {
  if (isInsideVm) {
    return MOBILE_UT_ENTRIES.Vm;
  }

  if (viewportClass === VIEWPORT_CLASSES.Desktop) {
    return MOBILE_UT_ENTRIES.Direct;
  }

  if (!hasUrlOrTask || !supportsPhone) {
    return MOBILE_UT_ENTRIES.Direct;
  }

  return MOBILE_UT_ENTRIES.PhoneHandoff;
}
